var storefrontApp = angular.module("storefrontApp");
//#region Home Service
storefrontApp.service('fabricsService', ['$http', function ($http) {
    return {
        getFabricsPageContent: function(){
            return $http.get('fabricspagecontent');
        }
    }
}]);
